import { Link } from 'react-router-dom';

const footerLinks = {
  学历提升: [
    { path: '/category/chengrengaokao', label: '成人高考' },
    { path: '/category/zixuekaoshi', label: '自学考试' },
    { path: '/category/wangluojiaoyu', label: '网络教育' },
    { path: '/category/guojiakaifang', label: '国家开放大学' },
  ],
  热门文章: [
    { path: '/article/article-1', label: '成人高考报名流程' },
    { path: '/article/article-2', label: '自考 vs 成考对比' },
    { path: '/article/article-3', label: '热门专业推荐' },
    { path: '/article/article-8', label: '学历提升五大价值' },
  ],
  关于我们: [
    { path: '/about', label: '品牌介绍' },
    { path: '/about', label: '信誉资质' },
    { path: '/about', label: '联系我们' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl text-primary-400">成人高清</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-5">
              专为在职人士打造的学历提升平台，提供高清视频课程、名师辅导与灵活学习方案，助力职场晋升。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="知乎">
                <i className="ri-zhihu-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-base text-background-100 mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 成人高清学历提升平台 版权所有 | 京ICP备2026000001号
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">服务条款</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">网站地图</span>
          </div>
        </div>
      </div>
    </footer>
  );
}